import React from 'react';
import './LightState.scss';
import ToggleSwitch from './ToggleSwitch'
class LightState extends React.Component {

  
  constructor(props){
    super(props);
    this.onToggle = this.onToggle.bind(this);
    this.state = { processing: this.props.processing }
  }

  onToggle(newValue) {
    console.log('LS', this.state)
    if(this.state.processing === 'processing') { return; }
    console.log('Starting to process')
    this.setState({ processing: 'processing' })
    if (typeof this.props.onChange === "function") this.props.onChange(this.props.name, newValue);
  }

  componentDidUpdate(prevProps, prevState) {
    
    // if(prevProps.processing !== this.props.processing) {
    //   console.log('props ', prevProps.processing, ' => ', this.props.processing)
    //   console.log('state ', prevState.processing, ' => ', this.state.processing)
    //   this.setState({processing: this.props.processing})
    // }
    if(this.props.processing !== prevProps.processing) {
      this.setState({processing: this.props.processing})
    }
  }

  render() {
    return (
      <div className={`LightState ${this.state.processing}` }>
        <p className="circuitIndicator">{this.props.circuit}</p>
        <h2>{this.props.name}</h2>
        <ToggleSwitch id={this.props.name} 
                      name={this.props.name}  
                      currentValue={this.props.lightState == 'on'} 
                      disabled={this.props.lightState == 'unavailable' } 
                      Text={['on', 'off']}
                      onChange={this.onToggle}/>
      </div>
    );
  }
}


export default LightState;
